// eslint-disable-next-line no-unused-vars
import { Match, FreeformMatch } from "bracket-system/types";
import { EventStageTypes } from "common/constants/EventStageTypes";
import {
    // eslint-disable-next-line no-unused-vars
    EventFormatStage,
    // eslint-disable-next-line no-unused-vars
    EventFormatBracket,
    // eslint-disable-next-line no-unused-vars
    EventFormatBracketColumn,
    // eslint-disable-next-line no-unused-vars
    EventFormatBracketColumnMatch,
    // eslint-disable-next-line no-unused-vars
    EventFormatBracketColumnMatchTarget,
    // eslint-disable-next-line no-unused-vars
    EventFormatBracketColumnTarget,
    // eslint-disable-next-line no-unused-vars
    EventFormatBracketScoringGroup,
} from "./eventFormatHelper";
// eslint-disable-next-line no-unused-vars
import { MatchPick } from "common/types/MatchPick";
import _ from "lodash";
// eslint-disable-next-line no-unused-vars
import { EventStage, EventSubstage } from "common/types/EventStage";
import { Colors } from "styles/Colors";

export function getBracketOptions() {
    return {
        style: {
            roundHeader: {
                fontSize: 16,
                backgroundColor: Colors.panel,
                fontColor: Colors.primary,
            },
            connectorColor: Colors.panel,
            connectorColorHighlight: Colors.pickstop,
        },
    };
}

export function getMatchCount(part, column, totalColumns) {
    if (part === "UB") {
        const inverse = Math.abs(column - totalColumns);
        return Math.pow(2, inverse - 1);
    }
    if (part === "LB") {
        const inverse = Math.abs(column - totalColumns);
        const grouping = Math.ceil(inverse / 2);
        return Math.pow(2, grouping - 1);
    }
    if (part === "GF") {
        return 1;
    }
}

export function getPartName(part) {
    if (part === "UB") {
        return "Upper Bracket";
    }
    if (part === "LB") {
        return "Lower Bracket";
    }
    if (part === "GF") {
        return "Grand Final";
    }
}

/**
 * @param {EventFormatBracket} bracket
 * @param {string} bracketMatchId
 * @returns {Match}
 */
export function findBracketMatchById(bracket, bracketMatchId) {
    if (bracket.freeform) {
        for (const part of bracket.freeformParts) {
            for (const col of part.columns) {
                for (const match of col.matches) {
                    if (String(match.id) === String(bracketMatchId)) {
                        return match;
                    }
                }
            }
        }
    } else {
        return (
            bracket.matches.upper?.find((m) => m.id === bracketMatchId) ??
            bracket.matches.lower?.find((m) => m.id === bracketMatchId)
        );
    }
}

/**
 *
 * @param {*} freeformParts
 * @param {*} bracketMatchId
 * @returns {FreeformMatch}
 */
export function findFreeformBracketMatchById(freeformParts, bracketMatchId) {
    for (const part of freeformParts) {
        for (const col of part.columns) {
            const match = col.matches.find((m) => m.id === bracketMatchId);
            if (match) {
                return match;
            }
        }
    }
}

/**
 * @param {EventFormatBracket} bracket
 * @param {string} bracketMatchId
 */
export function findColumnMatchById(bracket, bracketMatchId) {
    if (bracket.freeform) {
        for (const part of bracket.freeformParts) {
            for (const column of part.columns) {
                const columnMatch = column.matches.find(
                    (m) => m.bracketMatchId === bracketMatchId
                );
                if (columnMatch) {
                    return columnMatch;
                }
            }
        }
    } else {
        for (const part of bracket.parts) {
            for (const column of part.columns) {
                const columnMatch = column.matches.find(
                    (m) => m.bracketMatchId === bracketMatchId
                );
                if (columnMatch) {
                    return columnMatch;
                }
            }
        }
    }
}

/**
 * @param {EventFormatBracket} bracket
 * @param {EventFormatBracketColumnTarget} target
 * @returns {EventFormatBracketColumn}
 */
export function getBracketColumnByTarget(bracket, target) {
    if (bracket.freeform) {
        return bracket?.freeformParts
            ?.find((p) => p.identifier === target.part)
            ?.columns?.find((c) => c.index === target.col);
    } else {
        return bracket?.parts
            ?.find((p) => p.identifier === target.part)
            ?.columns?.find((c) => c.index === target.col);
    }
}

/**
 *
 * @param {EventFormatBracket} bracket
 * @param {EventFormatBracketColumnMatchTarget} target
 * @returns {string}
 */
export function getBracketMatchIdByTarget(bracket, target) {
    if (bracket.freeform) {
        return bracket?.freeformParts
            ?.find((p) => p.identifier === target.part)
            ?.columns?.find((c) => c.index === target.col)
            ?.matches?.find((m) => m.colIndex === target.colIndex)
            ?.bracketMatchId;
    } else {
        return bracket?.parts
            ?.find((p) => p.identifier === target.part)
            ?.columns?.find((c) => c.index === target.col)
            ?.matches?.find((m) => m.colIndex === target.colIndex)
            ?.bracketMatchId;
    }
}

/**
 *
 * @param {EventFormatBracket} bracket
 * @param {EventFormatBracketColumnMatchTarget} target
 * @returns {EventFormatBracketColumnMatch}
 */
export function getBracketMatchByTarget(bracket, target) {
    if (bracket.freeform) {
        return bracket?.freeformParts
            ?.find((p) => p.identifier === target.part)
            ?.columns?.find((c) => c.index === target.col)
            ?.matches?.find((m) => m.colIndex === target.colIndex);
    } else {
        return bracket?.parts
            ?.find((p) => p.identifier === target.part)
            ?.columns?.find((c) => c.index === target.col)
            ?.matches?.find((m) => m.colIndex === target.colIndex);
    }
}

/**
 *
 * @param {EventFormatBracket} bracket
 * @param {EventFormatBracketColumnTarget} target
 * @returns {string[]}
 */
export function getBracketMatchIdsByTargetColumn(bracket, target) {
    if (bracket.freeform) {
        return bracket?.freeformParts
            ?.find((p) => p.identifier === target.part)
            ?.columns?.find((c) => c.index === target.col)
            ?.matches.map((m) => m.bracketMatchId);
    } else {
        return bracket?.parts
            ?.find((p) => p.identifier === target.part)
            ?.columns?.find((c) => c.index === target.col)
            ?.matches.map((m) => m.bracketMatchId);
    }
}

/**
 * Cascade a freeform part identifier rename to every reference that keys on it
 * (own columns/matches, loser paths, scoring groups, views) so nothing is orphaned.
 *
 * @param {EventFormatBracket} bracket
 * @param {string} oldId
 * @param {string} newId
 */
export function renameFreeformPartIdentifier(bracket, oldId, newId) {
    if (!bracket || oldId === newId) {
        return;
    }

    for (const part of bracket.freeformParts ?? []) {
        for (const col of part.columns ?? []) {
            if (col.part === oldId) col.part = newId;
            for (const match of col.matches ?? []) {
                if (match.part === oldId) match.part = newId;
                if (match.loserPath?.part === oldId) match.loserPath.part = newId;
            }
        }
    }
    for (const group of bracket.scoringGroups ?? []) {
        for (const col of group.columns ?? []) {
            if (col.part === oldId) col.part = newId;
        }
    }
    for (const view of bracket.views ?? []) {
        for (const match of view.matches ?? []) {
            if (match.part === oldId) match.part = newId;
        }
    }
}

// Edit-mode pre-fill. Null when no official pick maps into this bracket.
export function getSeededUserPicksFromOfficial(
    bracket,
    currentEventStage,
    currentEventSubstage,
    userPicks,
    officialPicks
) {
    const full = userPicks ?? [];
    const inSub = (p) =>
        p.eventStageId === currentEventStage.id &&
        p.eventSubstageId === currentEventSubstage.id;

    if (full.some(inSub)) {
        return null;
    }

    const resolvable = (officialPicks ?? []).filter(
        (p) =>
            inSub(p) &&
            !!getBracketMatchIdByTarget(bracket, {
                part: p.bracketPart,
                col: p.bracketCol,
                colIndex: p.bracketColIndex,
            })
    );

    return resolvable.length > 0 ? full.concat(_.cloneDeep(resolvable)) : null;
}

/**
 *
 * @param {any} eventData
 * @param {EventStage} currentEventStage
 * @param {EventSubstage} currentEventSubstage
 * @param {EventFormatStage} currentStage
 * @param {EventFormatBracket} bracket
 * @param {MatchPick[]} userPicks
 * @param {MatchPick[]} officialPicks
 */
export function parsePicksIntoBracketMatches(
    eventData,
    currentEventStage,
    currentEventSubstage,
    currentStage,
    bracket,
    userPicks,
    officialPicks
) {
    // If Swiss Stage or Group stage with no brackets, skip this.
    if (currentStage.type === EventStageTypes.Swiss) {
        return;
    }

    if (
        currentStage?.type === EventStageTypes.Group &&
        !currentStage.groupStageDetails?.hasGroupBrackets
    ) {
        return;
    }

    if (bracket.freeform) {
        return parsePicksIntoFreeformBracketMatches(
            eventData,
            currentEventStage,
            currentEventSubstage,
            currentStage,
            bracket,
            userPicks,
            officialPicks
        );
    }

    const teams = eventData.teams;
    userPicks = userPicks?.filter(
        (p) =>
            p.eventStageId === currentEventStage.id &&
            p.eventSubstageId === currentEventSubstage.id
    );

    officialPicks = officialPicks.filter(
        (p) =>
            p.eventStageId === currentEventStage.id &&
            p.eventSubstageId === currentEventSubstage.id
    );

    const sourcePicks = userPicks?.length === 0 ? officialPicks : userPicks;
    bracket = _.cloneDeep(bracket);

    for (let pick of sourcePicks) {
        const bracketMatchId = getBracketMatchIdByTarget(bracket, {
            part: pick.bracketPart,
            col: pick.bracketCol,
            colIndex: pick.bracketColIndex,
        });

        // Abios gives us crap matches sometimes, don't let it ruin our site.
        if (!bracketMatchId) {
            continue;
        }

        const bracketMatch = findBracketMatchById(bracket, bracketMatchId);

        const topTeam = teams.find((t) => t.id === pick.topTeamId);
        const botTeam = teams.find((t) => t.id === pick.bottomTeamId);

        const started = pick.topTeamScore || pick.bottomTeamScore;
        const topTeamScore = started ? (pick.topTeamScore ?? 0).toString() : "";
        const bottomTeamScore = started
            ? (pick.bottomTeamScore ?? 0).toString()
            : "";

        bracketMatch.participants = [
            {
                id: topTeam?.id ?? "",
                resultText: topTeamScore,
                isWinner: pick.winnerTeamId === topTeam?.id,
                status: "PLAYED",
                name: topTeam?.abbreviation ?? "",
                logoUrl: topTeam?.logoUrl,
                correctParticipant:
                    userPicks.length === 0
                        ? false
                        : correctWinnerPick(pick, topTeam?.id, officialPicks),
                correctPlacement:
                    userPicks.length === 0 ? false : correctPlacement(),
            },
            {
                id: botTeam?.id ?? "",
                resultText: bottomTeamScore,
                isWinner: pick.winnerTeamId === botTeam?.id,
                status: "PLAYED",
                name: botTeam?.abbreviation ?? "",
                logoUrl: botTeam?.logoUrl,
                correctParticipant:
                    userPicks.length === 0
                        ? false
                        : correctWinnerPick(pick, botTeam?.id, officialPicks),
                correctPlacement:
                    userPicks.length === 0 ? false : correctPlacement(),
            },
        ];
    }

    return bracket.matches;
}

/**
 *
 * @param {any} eventData
 * @param {EventStage} currentEventStage
 * @param {EventSubstage} currentEventSubstage
 * @param {EventFormatStage} currentStage
 * @param {EventFormatBracket} bracket
 * @param {MatchPick[]} userPicks
 * @param {MatchPick[]} officialPicks
 */
export function parsePicksIntoFreeformBracketMatches(
    eventData,
    currentEventStage,
    currentEventSubstage,
    currentStage,
    bracket,
    userPicks,
    officialPicks
) {
    const teams = eventData.teams;
    userPicks = userPicks?.filter(
        (p) =>
            p.eventStageId === currentEventStage.id &&
            p.eventSubstageId === currentEventSubstage.id
    );

    officialPicks = officialPicks.filter(
        (p) =>
            p.eventStageId === currentEventStage.id &&
            p.eventSubstageId === currentEventSubstage.id
    );

    const sourcePicks = userPicks?.length === 0 ? officialPicks : userPicks;
    bracket = _.cloneDeep(bracket);

    for (let pick of sourcePicks) {
        const bracketMatchId = getBracketMatchIdByTarget(bracket, {
            part: pick.bracketPart,
            col: pick.bracketCol,
            colIndex: pick.bracketColIndex,
        });

        // Abios gives us crap matches sometimes, don't let it ruin our site.
        if (!bracketMatchId) {
            continue;
        }

        const bracketMatch = findBracketMatchById(bracket, bracketMatchId);

        const topTeam = teams.find((t) => t.id === pick.topTeamId);
        const botTeam = teams.find((t) => t.id === pick.bottomTeamId);

        const started = pick.topTeamScore || pick.bottomTeamScore;
        const topTeamScore = started ? (pick.topTeamScore ?? 0).toString() : "";
        const bottomTeamScore = started
            ? (pick.bottomTeamScore ?? 0).toString()
            : "";

        bracketMatch.participants = [
            {
                id: topTeam?.id ?? "",
                resultText: topTeamScore,
                isWinner: pick.winnerTeamId === topTeam?.id,
                status: "PLAYED",
                name: topTeam?.abbreviation ?? "",
                logoUrl: topTeam?.logoUrl,
                correctParticipant:
                    userPicks.length === 0
                        ? false
                        : correctWinnerPick(pick, topTeam?.id, officialPicks),
                correctPlacement:
                    userPicks.length === 0 ? false : correctPlacement(),
            },
            {
                id: botTeam?.id ?? "",
                resultText: bottomTeamScore,
                isWinner: pick.winnerTeamId === botTeam?.id,
                status: "PLAYED",
                name: botTeam?.abbreviation ?? "",
                logoUrl: botTeam?.logoUrl,
                correctParticipant:
                    userPicks.length === 0
                        ? false
                        : correctWinnerPick(pick, botTeam?.id, officialPicks),
                correctPlacement:
                    userPicks.length === 0 ? false : correctPlacement(),
            },
        ];
    }

    return bracket.freeformParts;
}

// Green = the user picked this team to win the match and it actually won.
function correctWinnerPick(pick, teamId, officialPicks) {
    if (!teamId || pick.winnerTeamId !== teamId) {
        return false;
    }
    const official = officialPicks?.find(
        (op) =>
            op.bracketPart === pick.bracketPart &&
            op.bracketCol === pick.bracketCol &&
            op.bracketColIndex === pick.bracketColIndex
    );
    return official?.winnerTeamId === teamId;
}

function correctPlacement() {
    return false;
}
